import * as React from "react";
const SvgSwitch20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M3.914 9H13V7H3.5l1.8-2.4-1.6-1.2-3 4-.52.694.613.613 3 3 1.414-1.414L3.914 9Zm12.172 2H7v2h9.5l-1.8 2.4 1.6 1.2 3-4 .52-.694-.613-.613-3-3-1.414 1.414L16.086 11Z",
      clipRule: "evenodd"
    })
  );
export default SvgSwitch20Px;
